import { Expose } from "class-transformer";
import type { RealEstateCurrentAddressTypeEnum } from "../../../../features/profile/constants/real-estate/real-estate-current-address-type.enum";
import type { RealEstateTenureTypeEnum } from "../../../../features/profile/constants/real-estate/real-estate-tenure-type.enum";

export class RealEstateRelationshipDto {
  @Expose()
  realEstateTenureType?: RealEstateTenureTypeEnum;

  @Expose()
  realEstateTenureTypeOther?: string;

  @Expose()
  realEstateTenureShare?: number;

  @Expose()
  realEstateMortgage?: boolean;

  @Expose()
  realEstateResidualMortgage?: number;

  @Expose()
  realEstateRentContractRegistered?: boolean;

  @Expose()
  realEstateRentContractYear?: number;

  @Expose()
  realEstateRentMonthlyRent?: number;

  @Expose()
  realEstateMainHome?: boolean;

  @Expose()
  currentAddressType?: RealEstateCurrentAddressTypeEnum;

  @Expose()
  livesInCareFacility?: boolean;
}
